<template>
  <b-container fluid class="mt">
    <b-row align-h="center" class="text-center">
      <b-col md="4" >
        <form>
          <img class="mb-4" src="../../assets/favicon.svg" alt="" width="72" height="72">
          <h1 class="h3 mb-3 font-weight-normal">商城後台管理系統</h1>
          <label for="form-input-username" class="sr-only">Email address</label>
          <b-input
            v-model="username"
            id="form-input-username"
            class="mb-2 mr-sm-2 mb-sm-0 mt-2"
            placeholder="帳號"
            required
            autofocus
          ></b-input>
          <label for="form-input-password" class="sr-only">密碼</label>
          <b-input
            v-model="password"
            id="form-input-password"
            class="mb-2 mr-sm-2 mb-sm-0 mt-2"
            type="password"
            placeholder="密碼"
            required
            @keydown.enter="login"
          ></b-input>
          <div class="mb-3"></div>
          <b-button :variant="loginBtnVariant" class="w-100" @click.prevent="login" :disabled="loginBtnDisable">
            <transition name="fade" mode="out-in">
              <span v-if="busy==='ok'">
                <font-awesome-icon icon="check" />
              </span>
              <span v-else-if="busy==='fail'">
                <font-awesome-icon icon="times" />
              </span>
              <span v-else-if="busy">
                <b-spinner label="Spinning"></b-spinner>
              </span>
              <span v-else>登入</span>
            </transition>
          </b-button>
          <p class="mt-5 mb-3 text-muted">© 2020 - </p>
        </form>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
library.add(faCheck, faTimes)
export default {
  data () {
    return {
      username: '',
      password: '',
      busy: false
    }
  },
  computed: {
    loginBtnVariant () {
      if (this.busy === 'fail') {
        return 'danger'
      }
      if (this.busy === 'ok') {
        return 'success'
      }
      if (this.busy) {
        return 'light'
      }
      return 'primary'
    },
    loginBtnDisable () {
      return Boolean(!(this.username && this.password) || this.busy)
    }
  },
  methods: {
    async login () {
      if (this.loginBtnDisable) return
      this.busy = true
      try {
        await this.$api.loginAdmin({
          username: this.username,
          password: this.password
        })
        this.busy = 'ok'
        this.$bvToast.toast('稍後將自動跳轉。', {
          title: '登入成功',
          variant: 'success'
        })
        setTimeout(() => {
          this.$router.push('/admin')
        }, 3000)
      } catch (err) {
        this.busy = 'fail'
        setTimeout(() => {
          this.busy = false
        }, 3000)
      } finally {
        this.username = ''
        this.password = ''
      }
    }
  }
}
</script>
<style scoped>
  @media (min-width: 576px) {
    .mt {
      margin-top: 10rem;
    }
  }
  @media (max-width: 576px) {
    .mt {
      margin-top: 5rem;
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>